import Photo from './Photo';
import SmartLink from './SmartLink';
import { IconInstagram } from './Icons';
import { Horizon, Peeks, splitArt } from './Art';

export default function Contact({ contact, site, art }) {
  const { peeks, horizon } = splitArt(art);
  return (
    <section id="contact" className={`sec sec--abyss contact ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="contact-title">
      <div className="frieze frieze--sea" aria-hidden="true" />
      <Peeks items={peeks} />
      <div className="wrap">
        <h2 id="contact-title" className="display">{contact.heading}</h2>
        <div className={`contact-grid ${contact.newsSrc ? '' : 'contact-grid--single'}`}>
          <div className="contact-book">
            {contact.intro && <p className="lede">{contact.intro}</p>}
            <a className="contact-email" href={`mailto:${site.email}`}>{site.email}</a>

            <div className="contact-ig">
              {contact.igPhoto && (
                <SmartLink url={site.instagram} className="ig-art" aria-label="Instagram">
                  <Photo src={contact.igPhoto} alt="" />
                </SmartLink>
              )}
              <div>
                {contact.igHeading && <h3 className="display display--s">{contact.igHeading}</h3>}
                {contact.igText && <p>{contact.igText}</p>}
                <SmartLink url={site.instagram} className="btn btn--ghost-light">
                  <IconInstagram width="18" height="18" /> {site.instagramHandle}
                </SmartLink>
              </div>
            </div>
          </div>

          {contact.newsSrc && (
            <div className="contact-news">
              {contact.newsHeading && <h3 className="display display--s">{contact.newsHeading}</h3>}
              <div className="news-frame tile-frame">
                <iframe
                  title="Join the mailing list"
                  src={contact.newsSrc}
                  width={340}
                  height={contact.newsHeight}
                  scrolling="no"
                  loading="lazy"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
